import React, {useState, useMemo, useEffect} from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { VARPATH } from "../../../../constants";
import Typography from '@mui/material/Typography';
import useSafeState from '../../../../useSafeState' 
import * as api from '../../../../Auth/auth'
import TableComp from '../../../../components/Table/TableComp';
import Alert from "@mui/material/Alert";
import Button from '@mui/material/Button';


export default function GetHardPathoTable() {

  const navigate = useNavigate();

  const [value, setValue] = useSafeState({});
  const [data, setData] = useState(useMemo(() => []));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
    
  useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    axios.get(VARPATH, data)
    .then((response) => {
        const d = handleData(response.data)
        setData( d )
        setLoading(false)
              // NO MEMORY LEAK
        setValue({ key: 'value' });
    })
    .catch(function (error) {
      //throw new Error(error)
      setError(error.toJSON());
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        //console.log(error.response.data, error.response.status);
        
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
        //console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        //console.log('Error', error.message);
      }
      //console.log(error.config);
      console.log("Error")
    })
  }
    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {    'col1': response[i].id,
                                            'col2': response[i].sample,
                                            'col3': response[i].SYMBOL,
                                            'col4': response[i].Uploaded_variation,
                                            'col5': response[i].VARIANT_CLASS,
                                            'col6': response[i].Consequence,
                                            'col7': response[i].GENOTYPE,
                                            'col8': response[i].SNPS,
                                            'col9': response[i].Existing_variation,
                                            'col10': response[i].CLIN_SIG,
                                            'col11': response[i].owner,
                                            
                                        },
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
          {
          header: 'SAMPLE',
          accessorKey: 'col2', // accessor is the "key" in the data
          cell: info => info.getValue(),
          footer: props => props.column.id,
          },
          {
            header: 'GENE',
            accessorKey: 'col3',
            cell: info => info.getValue(),
            footer: props => props.column.id,
            },
            {
              header: 'TYPE',
              accessorKey: 'col5',
              cell: info => info.getValue(),
              footer: props => props.column.id,
              },
              {
                header: 'SNPs',
                accessorKey: 'col8',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                },
                {
                  header: 'CONSEQUENCE',
                  accessorKey: 'col6',
                  cell: info => info.getValue(),
                  footer: props => props.column.id,
                  },
                {
                  accessorKey: 'col10',
                  header: 'clinvar - CLASSIFICATION',
    //              header: () => <Typography component="span" variant="h6" sx={{color: "traffic.red"}}>'clinvar' CLASSIFICATION</Typography>,
                  cell: info =>  info.getValue() === 'pathogenic' ? <Typography component="span" variant="h6" sx={{color: "traffic.red"}}>{info.getValue()}</Typography> : info.getValue(),
                  footer: props => props.column.id,  
                },
              {
                header: 'VARIATION',
                accessorKey: 'col4',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                },
                {
                  header: 'GENOTYPE',
                  accessorKey: 'col7',
                  cell: info => info.getValue(),
                  footer: props => props.column.id,
                  },
                    {
                      header: 'DB_IDs',
                      accessorKey: 'col9',
                      cell: info => info.getValue(),
                      footer: props => props.column.id,
                      },
      ],
      []
      )

return (
<>
<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableComp columns={columns} data={data} />
</div>

{error  ? (
  <Alert severity="error" sx={{mt:2}}>
      <Typography variant="body2"  sx={{fontWeight: '500'}}> {error.message} </Typography>
      <Button variant="contained" onClick={() => { navigate("/", { replace: true }) }} sx={{mt:1, bgcolor: 'tertiary.dark', color:'common.white'}}> Try again </Button>
  </Alert>
  ) : (null)}

</>
);
}